<template>
    <div>
        <div v-for="(item,i) in dataList" :key="i">
            <p class="text-bold text-l" :class="i!=0?'p-title':'p-title-1'">{{item.title}}</p>
            <div class="flex  flex-wrap">
                <span v-for="(t,index) in item.content" :key="'t'+index" class="margin-top-xs" :class="index%3!=0?'margin-left-sm':''">{{t.name}}</span>
            </div>
        </div>
    </div>
</template>
<script>
    import api from "@/utils/api"
    export default {
        data() {
            return {
                dataList: []
            }
        },
        watch: {
            "$route.path": {
                handler() {
                    this.getData()
                },
                immediate: true
            }
        },
        methods: {
            async getData() {
                let res = await api.getVipMemberApi()
                if (res.code == 200) {
                    this.dataList = [{
                        title: '轮值理事长单位',
                        content: res.data[1]
                    }, {
                        title: '副理事长单位',
                        content: res.data[2]
                    }, {
                        title: '理事单位',
                        content: res.data[3]
                    }, {

                        title: '会员单位',
                        content: res.data[4]
                    }]
                }
            }
        }
    }
</script>
<style scoped>
    span {
        display: inline-block;
        background: #F8F8F8;
        width: 270px;
        padding-left: 20px;
        height: 40px;
        line-height: 40px;
        color: #252B3A;
        font-size: 14px;
    }
    .p-title{
        margin: 30px 0px 10px 0px;
    }
    .p-title-1{
        margin: 18px 0px 10px 0px;
    }
</style>